import {Injectable} from '@angular/core';
import {CookieService as NgxCookieService} from 'ngx-cookie-service';
import {COOKIE_OPTIONS} from 'src/app/config/cookie.config';

@Injectable({
  providedIn: 'root'
})
export class CookieService {

  constructor(
    private cookieService: NgxCookieService,
  ) {
  }

  public set(name: string, value: string, path: string ='/') {
    this.cookieService.set(name, value, COOKIE_OPTIONS.expires, path, COOKIE_OPTIONS.domain, COOKIE_OPTIONS.secure, COOKIE_OPTIONS.sameSite);
  }

  public get(name: string) {
    return this.cookieService.get(name);
  }

  public check(name: string) {
    return this.cookieService.check(name);
  }

  public delete(name: string, path: string ='/') {
    this.cookieService.delete(name, path, COOKIE_OPTIONS.domain, COOKIE_OPTIONS.secure, COOKIE_OPTIONS.sameSite);
  }
}
